import script from "./ProductOption.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductOption.vue?vue&type=script&setup=true&lang=js"

import "./ProductOption.vue?vue&type=style&index=0&id=129fecbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129fecbc"]])

export default __exports__